import React from "react";

import { IPortfolio, ISimpleTeachingMaterial } from "../../../state";

import OnePagePortfolioAssessment from "./OnePagePortfolioAssessment";
import Retrospective from "./Retrospective";
import styles from "./PortfolioPreview.module.scss";

type PortfolioPreviewProps = {
  teachingMaterial: ISimpleTeachingMaterial;
  portfolio?: IPortfolio;
  onePagePortfolioId: number | null;
};

const INITIAL_PORTFOLIO: IPortfolio = {
  id: 0,
  portfolio_type: 0,
  teaching_material_id: 0,
  key_issue_answer: null,
  summary_issue_answers: null,
  lesson00_issue_answers: null,
  lesson01_issue_answers: null,
  lesson02_issue_answers: null,
  lesson03_issue_answers: null,
  one_page_portfolio_assessments: null,
};

const PortfolioPreview = (props: PortfolioPreviewProps) => {
  const teachingMaterial = props.teachingMaterial;
  const portfolio = props.portfolio ?? INITIAL_PORTFOLIO;

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>{teachingMaterial.name}の学び</div>
      {props.onePagePortfolioId && (
        <OnePagePortfolioAssessment portfolio={portfolio} />
      )}
      <Retrospective
        teachingMaterial={teachingMaterial}
        portfolio={portfolio}
      />
    </div>
  );
};

export default PortfolioPreview;
